import { isBrowser } from '@dx-ui/utilities-is-browser';
import type { DtrumApi } from '@dynatrace/dtrum-api-types';

declare global {
  interface Window {
    dtrum?: DtrumApi;
    dynatrace?: {
      addEventModifier?: (
        eventModifier: (
          jsonEvent: Readonly<Record<string, unknown>>,
          eventContext?: unknown
        ) => Record<string, unknown>
      ) => () => void;
    };
  }
}

/**
 * Simple wrapper around the Dynatrace RUM API.
 * {@link https://www.dynatrace.com/support/doc/javascriptapi/interfaces/dtrum_types.DtrumApi.html}
 */
export const dynatrace = isBrowser ? window.dtrum : undefined;
